import React from 'react';
import './App.css';
import Author30daysChart from './components/Author30daysChart'
import TotalPostsChart from './components/TotalPostsChart'
import TagUsageChart from './components/TagUsageChart'
import PostingTimeChart from './components/PostingTimeChart'
import { BrowserRouter as Router, Switch, Route, Link } from 'react-router-dom';

function App() {
  return (
    <div className="App">
      <Router>
        <div>
          <div className="row" className="hdr" style={{"padding-bottom":"2em"}}>
            <div className="col-sm-12 btn btn-warning">
              Hive中文区数据统计
            </div>
          </div>
          <div class="row">
            <div class="col-sm-2">
            </div>
            <div class="col-sm-2">
              <Link to={'/Author30daysChart'} className="nav-link btn btn-info">作者活跃度</Link>
            </div>
            <div class="col-sm-2">
              <Link to={'/TotalPostsChart'} className="nav-link btn btn-info">发帖总数</Link>
            </div>
            <div class="col-sm-2">
              <Link to={'/TagUsageChart'} className="nav-link btn btn-info">标签使用</Link>
            </div>
            <div class="col-sm-2">
              <Link to={'/PostingTimechart'} className="nav-link btn btn-info">发帖时间</Link>
            </div>
            <div class="col-sm-2">
            </div>
          </div>
        </div>
        <div className="container">
          <Switch>
            <Route path='/Author30daysChart' component={Author30daysChart} />
            <Route path='/TotalPostsChart' component={TotalPostsChart} />
            <Route path='/TagUsageChart' component={TagUsageChart} />
            <Route path='/PostingTimechart' component={PostingTimeChart} />
          </Switch>
        </div>
      </Router>
    </div>
  );
}

export default App;
